module.exports = __webpack_public_path__ + "img/apps_image.49fee99d.jpg";